import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import HandlerApp from "../../../utils/handlerApp";
import { useTranslation } from "react-i18next";
import { useFetch } from "../../../hooks/useFecth";

const AccessLogView = ()=>{
    const endpoint = "accesslog";
    const handlerApp = HandlerApp();
    const api = useFetch();
    const nav = useNavigate();

    const [t,i18n] = useTranslation("global");
    const [data,setData] = useState({});
    const [title,setTitle] = useState("");
    

    const {id} = useParams();
    
    useEffect(()=>{
        handlerApp.setLoader(true);
        api.get(endpoint+"/"+id)
        .then(response =>{
            if(response.success){
                handlerApp.setLoader(false);
                let data = response.data[0];
                setTitle(data.category_name);
                setData(data);
            }else{
                handlerApp.handlerResponse(response);
                handlerApp.setLoader(false);
            }
        })
        .catch(error=>{
            handlerApp.showError(t(error.message));
            handlerApp.setLoader(false);
        })
    },[])

    const back = ()=>{
        nav(-1);
    }

    return(
        <div className="app">
            <div className="container bold-container-content">
                <span className="material-symbols-outlined absolute" role="button" onClick={back}>arrow_back</span>
                <div className="title-section-forms">
                    {title}
                </div>
                <div className="row np-row">
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-4 mb-2">
                                <dt>{t('name')}</dt>
                                <dd>{data.full_name}</dd>
                            </div>
                            <div className="col-md-4 mb-2">
                                <dt>{t('user')}</dt>
                                <dd>{data.user_username}</dd>
                            </div>
                            <div className="col-md-4 mb-2">
                                <dt>{t('accessLog.date')}</dt>
                                <dd>{ data.accesslog_created_at }</dd>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer-section-view row">
                    <span className="divisor"></span>
                    <div className="col-md-6">
                        <span className="text-gray light small-text">{t('createdBy')}: {data.full_name}</span>
                    </div>
                    <div className="col-md-6">
                        <span className="text-gray light small-text">{t('createdAt')}: {handlerApp.getDate(data.accesslog_created_at)}</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AccessLogView;